// Module
var code = "<div class=\"row\">\n  <div class=\"col-xs-7\">\n    <date-picker ng-model=\"date\"></date-picker>\n  </div>\n  <div class=\"col-xs-5\">\n    <time-picker ng-model=\"time\"></time-picker>\n  </div>\n</div>\n";
// Exports
module.exports = code;